
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.75 12.023a2.625 2.625 0 1 0 5.25 0 2.625 2.625 0 1 0-5.25 0Zm17.25 0a2.625 2.625 0 1 0 5.25 0 2.625 2.625 0 1 0-5.25 0Zm-8.625 0a2.625 2.625 0 1 0 5.25 0 2.625 2.625 0 1 0-5.25 0Z","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    